import React from 'react';

const chitData = [
  { month: 1, contribution: 3350, halfShare: 1680, },
  { month: 2, contribution: 3290, halfShare: 1650, fullChit: 4400, halfChit: 2200 },
  { month: 3, contribution: 3250, halfShare: 1630, fullChit: 4400, halfChit: 2200 },
  { month: 4, contribution: 3240, halfShare: 1620, fullChit: 4400, halfChit: 2200 },
  { month: 5, contribution: 3200, halfShare: 1600, fullChit: 4400, halfChit: 2200 },
  { month: 6, contribution: 3150, halfShare: 1580, fullChit: 4400, halfChit: 2200 },
  { month: 7, contribution: 3100, halfShare: 1550, fullChit: 4400, halfChit: 2200 },
  { month: 8, contribution: 3070, halfShare: 1540, fullChit: 4400, halfChit: 2200 },
  { month: 9, contribution: 3020, halfShare: 1510, fullChit: 4400, halfChit: 2200 },
  { month: 10, contribution: 2990, halfShare: 1500, fullChit: 4400, halfChit: 2200 },
  { month: 11, contribution: 2950, halfShare: 1480, fullChit: 4400, halfChit: 2200 },
  { month: 12, contribution: 2890, halfShare: 1450, fullChit: 4400, halfChit: 2200 },
  { month: 13, contribution: 2840, halfShare: 1420, fullChit: 4400, halfChit: 2200 },
  { month: 14, contribution: 2750, halfShare: 1380, fullChit: 4400, halfChit: 2200 },
  { month: 15, contribution: 2690, halfShare: 1350, fullChit: 4400, halfChit: 2200 },
  { month: 16, contribution: 2600, halfShare: 1300, fullChit: 4400, halfChit: 2200 },
  { month: 17, contribution: 2500, halfShare: 1250, fullChit: 4400, halfChit: 2200 },
  { month: 18, contribution: 2400, halfShare: 1200, fullChit: 4400, halfChit: 2200 },
  { month: 19, contribution: 2300, halfShare: 1150, fullChit: 4400, halfChit: 2200 },
  { month: 20, contribution: 2200, halfShare: 1100, fullChit: 4400, halfChit: 2200 },
  { month: 21, contribution: 2100, halfShare: 1050, fullChit: 4400, halfChit: 2200 },
  { month: 22, contribution: 1900, halfShare: 950, fullChit: 4400, halfChit: 2200 },
  { month: 23, contribution: 1750, halfShare: 880, fullChit: 4400, halfChit: 2200 },
  { month: 24, contribution: 1550, halfShare: 780, fullChit: 4400, halfChit: 2200 },
  { month: 25, contribution: 1350, halfShare: 680, fullChit: 4400, halfChit: 2200 },
  { month: 26, contribution: 1150, halfShare: 580, fullChit: 4400, halfChit: 2200 },
  { month: 27, contribution: 950, halfShare: 480, fullChit: 4400, halfChit: 2200 },
  { month: 28, contribution: 750, halfShare: 380, fullChit: 4400, halfChit: 2200 },
  { month: 29, contribution: 590, halfShare: 300, fullChit: 4400, halfChit: 2200 },
  { month: 30, contribution: 340, halfShare: 170, fullChit: 4400, halfChit: 2200 },
  { month: 31, contribution: 170, halfShare: 90, fullChit: 4400, halfChit: 2200 }
];

const totals = {
  contribution: 70380,
  halfShare: 35280,
  fullChit: 132000,
  halfChit: 66000
};

const ChitPlanTable = () => {
  return (
    <div className="bg-gray-100 min-h-screen py-10 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-7xl mx-auto bg-white shadow-xl rounded-2xl overflow-hidden">
        {/* Header Section */}
        <div className="p-8 sm:p-12 text-center bg-purple-600 text-white">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-2 leading-tight">
            1 Lakh Chit Plan
          </h1>
          <p className="text-lg sm:text-xl opacity-90">
            Secure Your Future, One Contribution at a Time
          </p>
        </div>

        {/* Call to Action and Summary */}
        <div className="p-8 sm:p-12 text-center bg-gray-50 border-b border-gray-200">
          <p className="text-gray-700 text-base sm:text-lg mb-6 max-w-2xl mx-auto">
            Join our 31-month chit plan to build significant savings. The table below details your monthly contributions and potential returns.
          </p>
          <a
            href="#"
            className="inline-block bg-purple-600 text-white font-bold py-3 px-8 rounded-full shadow-lg hover:bg-purple-700 transition duration-300 transform hover:scale-105"
            onClick={(e) => { e.preventDefault(); alert('Redirecting to application page...'); }}
          >
            Apply Now!
          </a>
        </div>

        {/* Table Section */}
        <div className="p-4 sm:p-8 overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200 rounded-lg overflow-hidden border border-gray-200">
            <thead className="bg-purple-50">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-4 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider"
                  rowSpan="2"
                >
                  Month
                </th>
                <th
                  scope="col"
                  className="px-6 py-4 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider"
                  colSpan="2"
                >
                  Before Winning the Bid
                </th>
                <th
                  scope="col"
                  className="px-6 py-4 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider"
                  colSpan="2"
                >
                  After Winning the Bid
                </th>
              </tr>
              <tr className="bg-purple-100">
                <th
                  scope="col"
                  className="px-6 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Contribution
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Half Share
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Full Chit
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Half Chit
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {chitData.map((row, index) => (
                <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800 text-center">{row.month}</td>
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800 text-center">{row.contribution}</td>
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800 text-center">{row.halfShare}</td>
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800 text-center">{row.fullChit}</td>
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800 text-center">{row.halfChit}</td>
                </tr>
              ))}
              {/* Totals Row */}
              <tr className="bg-purple-200 font-bold">
                <td className="px-6 py-3 text-sm text-gray-800 text-center">Total</td>
                <td className="px-6 py-3 text-sm text-gray-800 text-center">{totals.contribution}</td>
                <td className="px-6 py-3 text-sm text-gray-800 text-center">{totals.halfShare}</td>
                <td className="px-6 py-3 text-sm text-gray-800 text-center">{totals.fullChit}</td>
                <td className="px-6 py-3 text-sm text-gray-800 text-center">{totals.halfChit}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Footer Section */}
        <div className="p-8 sm:p-12 text-center text-gray-500 text-xs bg-gray-100">
          <p>&copy; 2025 Chit Plans Inc. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default ChitPlanTable;